import { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Product, ProductStatus } from 'src/constants';
import { loadProductStatus } from 'src/redux/actions/productStatusActions';
import { RootState } from 'src/redux/reducers/rootReducer';
import { useAppSelector } from './useAppSelector';
import { useEnv } from './useEnv';

/** @deprecated */
export const useProductStatus = () => {
  const dispatch = useDispatch();
  const isSessionExpired = useAppSelector(state => state.auth.isSessionExpired);
  const { data } = useSelector((state: RootState) => state.productStatus);

  const { isProdEnv } = useEnv();

  useEffect(() => {
    if (!isSessionExpired) dispatch(loadProductStatus());
  }, [isSessionExpired, dispatch]);

  const isAcceptanceApproved = useMemo(
    () =>
      !isProdEnv ||
      data.find(e => e.product === Product.Acceptance)?.status ===
        ProductStatus.RiskApproved,
    [data, isProdEnv],
  );

  const isDisbursementApproved = useMemo(
    () =>
      !isProdEnv ||
      data.find(e => e.product === Product.Disbursement)?.status ===
        ProductStatus.RiskApproved,
    [data, isProdEnv],
  );

  return { isAcceptanceApproved, isDisbursementApproved };
};
